import { useRef, type RefObject } from 'react'

const useMoveScrollTo = (externalElementRef?: RefObject<HTMLElement>) => {
    const internalElementRef = useRef<HTMLElement | null>(null)
    const RefInput = useRef<HTMLInputElement | null>(null)
    const RefElement = (externalElementRef ?? internalElementRef) as RefObject<HTMLElement>

    const onMoveToElement = (delay = 300) => {
        RefElement.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        window.setTimeout(() => {
            const el = RefInput.current
            el?.focus({ preventScroll: true })
            try {
                el?.setSelectionRange?.(el.value.length, el.value.length)
            } catch {}
        }, delay)
    }

    return { RefInput, RefElement, onMoveToElement }
}

export default useMoveScrollTo
